<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import ZjxxrkBrowse from "./ZjxxrkBrowse";
import ZjxxrkEdit from "./ZjxxrkEdit";
import ZjxxrkForm from "./ZjxxrkForm";
export default {
    name: "Zjxxrk",
    components: { ZjxxrkBrowse, ZjxxrkEdit, ZjxxrkForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "ZjxxrkEdit";
            } else if (this.editProps.showForm === true) {
                return "ZjxxrkForm";
            } else {
                return "ZjxxrkBrowse";
            }
        }
    }
};
</script>
